import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Card, Col, Form, FormInstance, Input, Row, Select } from 'antd';
import { InvoiceServiceFormValues } from '../InvoiceServiceForm.types';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';
import InvoiceNBSInfiniteSelect from '@/components/_common/InvoiceNBSInfiniteSelect';

interface Props {
  form: FormInstance<InvoiceServiceFormValues>;
}

const InvoiceServiceGeneralDataForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  const required = useDefaultEmptyFieldError();

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Form.Item name={['general', 'taskId']} hidden />

      <Card
        type="inner"
        title="Informações gerais"
        style={{ marginBottom: 24 }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <FloatingFormItem
              label="Descrição"
              name={['general', 'description']}
              rules={[required]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Unidade"
              name={['general', 'unitMeasurement']}
              rules={[
                required,
                { type: 'string', max: 5, message: 'Limite de 5 caracteres' },
              ]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Quantidade"
              name={['general', 'quantity']}
              initialValue={0}
              rules={[required]}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Preço unitário"
              name={['general', 'valueUnitary']}
              initialValue={0}
              rules={[required]}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Desconto condicionado"
              name={['general', 'conditionalDiscount']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Desconto incondicionado"
              name={['general', 'unconditionalDiscount']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Responsável retenção"
              name={['itemTaxes', 'withholdingResponsible']}
            >
              <Select
                allowClear
                options={[
                  {
                    value: '1',
                    label: 'Tomador',
                  },
                  {
                    value: '2',
                    label: 'Intermediário',
                  },
                ]}
              />
            </FloatingFormItem>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <FloatingFormItem
              label="Tributos federais retidos"
              name={['itemTaxes', 'federalTaxesWithheld']}
            >
              <Select
                allowClear
                options={[
                  {
                    value: 'true',
                    label: 'Sim',
                  },
                  {
                    value: 'false',
                    label: 'Não',
                  },
                ]}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12} lg={6}>
            <FloatingFormItem
              label="Código de serviço"
              name={['general', 'serviceItemList']}
            >
              <Input disabled={disabledFields} />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              label="Código NBS"
              name={['itemTaxes', 'nbsCode']}
            >
              <InvoiceNBSInfiniteSelect disabled={disabledFields} />
            </FloatingFormItem>
            <span>
              Em caso de dúvida, procure mais informações com sua contabilidade
            </span>
          </Col>
        </Row>
      </Card>

      <Card type="inner" title="Valores">
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={8}>
            <FloatingFormItem
              label="Valor total bruto"
              name={['general', 'grossServiceValue']}
              rules={[required]}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={8}>
            <FloatingFormItem
              label="Base cálculo"
              name={['general', 'taxBase']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={8}>
            <FloatingFormItem label="Deduções" name={['general', 'deductions']}>
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default InvoiceServiceGeneralDataForm;
